import { createContext, useContext } from "react";

import { type InteractModuleProperties } from "@skilitics/nautilus-endpoint-definition";

// Metadata is the create-wizard's working state for the new module.
// It mirrors the create/update payload (no owner/audit fields — those are server-assigned).
export type Metadata = Omit<InteractModuleProperties, "id"> & { readonly?: boolean };

export type CreateModuleSettings = {
  metadata: Metadata;

  utilizeAi: boolean;
  adaptToAudience: boolean;
  understood: boolean;
};

export type CreateModuleSettingsContext = CreateModuleSettings & {
  updateMetadata: (metadata: Partial<Metadata>) => void;

  setUtilizeAi: (utilizeAi: boolean) => void;
  setAdaptToAudience: (adaptToAudience: boolean) => void;
  setUnderstood: (understood: boolean) => void;

  reset: () => void;
};

export const CreateModuleSettingsContext = createContext<CreateModuleSettingsContext | undefined>(undefined);

export const useCreateModuleSettings = (): CreateModuleSettingsContext => {
  const context = useContext(CreateModuleSettingsContext);

  if (!context) throw new Error(`Expected CreateModuleSettingsContext in ancestor tree.`);

  return context;
};

CreateModuleSettingsContext.displayName = "CreateModuleSettingsContext";
